<app-header [logoImg]="logoImg" stickyLogoImg="../../../assets/imgs/logo/se2in_logo_fullwhite.png" [stickyHeaderWhite]="true"></app-header>
<app-counter [titleSectionProp]="titleSectionProp" [List]="List"></app-counter>
<app-nav-tabs></app-nav-tabs>
<app-footer></app-footer>